import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Row,
  Card,
  Col,
  Container,
  Badge,
  Form,
  InputGroup,
  Button,
  Tab,
  Nav,
  ButtonToolbar,
  ToggleButton,
  ToggleButtonGroup,
  Image,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import ItemsCarousel from "./common/ItemsCarousel";
import ChooseAddressCard from "./common/ChooseAddressCard";
import CheckoutItem from "./common/CheckoutItem";
import MutilUpload from "./common/MultipleImageUploadComponent";
import AddAddressModal from "./modals/AddAddressModal";
import FontAwesome from "./common/FontAwesome";
import Icofont from "react-icofont";
import { Multiselect } from "multiselect-react-dropdown";
import DataService from "../services/DataService";
import { alertCreation, alertError } from "../components/Alerts";
import SimpleReactValidator from "simple-react-validator";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class SuggestionTab extends React.Component {  
  constructor(props, context) {
    super(props, context);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    console.log(this.props.customSuggestions);

    this.state = {
      showAddressModal: false,
      createForm: { tab_type: 1 },
      addedItemscreateForm: {},
      showHideDelivery: false,
      tags: [],
      value: { min: 2, max:4 },

      options: [],
    };
  }
  getFoodPrice(val) {
    console.log(val);
    let foodObj = this.props.optionsFood.find((f) => f.id == val);
    console.log(foodObj);
    let price = typeof foodObj != "undefined" ? foodObj.price : 0;
    return price;
  }
  getFoodName(val) {
    console.log(val);
    let foodObj = this.props.optionsFood.find((f) => f.id == val);
    let name = typeof foodObj != "undefined" ? foodObj.name : "unknown";
    return name;
  }
  getPaymentType(val) {
    console.log(val, this.props.payOptions);

    let payObj = this.props.payOptions.find((p) => p.id === val);
    let name = typeof payObj != "undefined" ? payObj.name : "unknown";
    return name;
  }
  getChoiceType(val) {
    let choiceOptions = [
      { id: "1", name: "Mandatory" },
      { id: "2", name: "Optional" },
    ];
    let choiceObj = choiceOptions.find((p) => p.id === val);
    let name = typeof choiceObj != "undefined" ? choiceObj.name : "unknown";
    return name;
  }


  getQuestionType(val) {
    let choiceOptions = [
      { id: "2", name: "Multiple Selection" },
      { id: "1", name: "Single Selection" },
    ];
    let choiceObj = choiceOptions.find((p) => p.id == val+"");
    let name = typeof choiceObj != "undefined" ? choiceObj.name : "unknown";
    return name;
  }
  createAddedItemsFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.addedItemscreateForm };
    if (event.target.type == "text" || event.target.type == "textarea") {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;
      value = event.target.value;
      if (key == "food_type") {
        inputForm["item_price"] = this.getFoodPrice(value);
      }
    }

    inputForm[key] = value;
    this.setState({ addedItemscreateForm: inputForm });
  };
  createFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.createForm };

    if (
      event.target.type == "text" ||
      event.target.type == "textarea" ||
      event.target.type == "number"
    ) {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;

      value = event.target.value;
    }
    else if (event.target.type == "checkbox") {
      key = event.target.name;

      value = event.target.checked;
    }
    inputForm[key] = value;
    this.setState({ createForm: inputForm });
  };

  hideAddressModal = () => this.setState({ showAddressModal: false });

  hideDelivery(name) {
    this.setState({ showHideDelivery: !this.state.showHideDelivery });
  }

  getQty = ({ id, quantity }) => {
    //console.log(id);
    //console.log(quantity);
  };
  isTabFormValid() {
    return (
      this.validator.fieldValid("tab_title") &&
      this.validator.fieldValid("tab_type")
    );
  }
  isFoodItemFormValid() {
    return (
      this.validator.fieldValid("payment_type") &&
      this.validator.fieldValid("food_type")
    );
  }
  fieldValid;
  render() {
    const { tags } = this.state;
    return (
      <div>
        <div className="pt-2"></div>

        <span className="hidden">
          {/*this.props.shouldHide ? 'hidden' : ''*/}

          <div className="pt-2"></div>

          <div className="pt-2"></div>
          <div className="bg-white rounded shadow-sm p-4 osahan-payment">
            <span></span>
            <Card>
              <Card.Body>
                <h6 className="mb-1">Edit Customization</h6>
                <Form.Group className="col-md-12">
                  <Form.Label>Tab Title</Form.Label>
                  {
                  
                  this.validator.message(
                    "tab_title",
                    this.state.createForm["tab_title"],
                    "required|min:2|max:15"
                  )}

                  <InputGroup>
                    <Form.Control
                      type="text"
                      onChange={this.createFormHandler}
                      name="tab_title"
                      placeholder="Enter Tab Title"
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group className="col-md-12">
                  <Form.Label>Tab Type</Form.Label>
                  {this.validator.message(
                    "tab_type",
                    this.state.createForm["tab_type"],
                    "required"
                  )}

                  <Form.Control
                    as="select"
                    onChange={this.createFormHandler}
                    name="tab_type"
                  >
                    <option value="1">
                     Add side dish or extra food items with this Item
                    </option>
                    <option value="2">
                      Customization available for this Item
                    </option>
                  </Form.Control>
                </Form.Group>

                <Form.Group className="col-md-12">
                  
<Form.Check
          type="checkbox"
          name="is_mandatory"
          label="mandatory customaization"
          checked= {this.state.createForm['is_mandatory']}

          onClick={
          this.createFormHandler
            }
        />
                  </Form.Group>
                
                  <Form.Group className="col-md-12">
                  
                  <Form.Check
                            type="checkbox"
                            name="enable_quantity_limits"
                            label="Apply Limit on customer choices- (Min-Max number of customer choices)"
                            checked= {this.state.createForm['enable_quantity_limits']}
                  
                            onClick={
                            this.createFormHandler
                              }
                          />
                          
                                    </Form.Group>
                                    {(this.state.createForm['enable_quantity_limits']==true)&&
                  <Form.Group className="col-md-12">

                                    <InputRange
        maxValue={10}
        minValue={0}
        allowSameValues={true}
        value={this.state.value}
        onChange={
          (value)=>{
            let inputForm = { ...this.state.createForm };
            inputForm['number_of_items_required']=value.min;
            inputForm['max_number_of_items_required']=value.max;
            this.setState({createForm:inputForm,value:value});

          }
          } />


</Form.Group>}
            <Nav>
                  <Nav.Link
                    eventKey={0}
                    as={NavLink}
                    activeclassname="active"
                    className="pt-3"
                    to="#"
                    onClick={(e) => {
                      if (this.isTabFormValid() == true) {
                        e.target.setAttribute("disabled", "disabled");
console.log(this.state.createForm);
                        this.props.addNewTab(this.state.createForm);
                      } else {
                        this.validator.showMessages();
                      }
                    }}
                  >
                    Add New tab
                    <Icofont icon="plus-circle" />
                    <span className="sr-only">(current)</span>
                  </Nav.Link>
                </Nav>
              </Card.Body>
            </Card>

            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row>
                <Col sm={4} className="pr-0">
                  <Nav variant="pills" className="flex-column">
                    {this.props.customSuggestions.map((customObj,index) => {

                      if(!customObj.removed){
                      let tabId = "item" + customObj.id;
                      return (
                        <Nav.Link eventKey={tabId}>
                          <Icofont icon="food-basket" /> {
                          (customObj.title)?((index+1)+":"+customObj.title):(index+1)+": Untittled"
                          
                          }
                        </Nav.Link>
                      );
                      }
                    })}
                  </Nav>
                </Col>
                <Col sm={8} className="pl-0">
                  <Tab.Content className="h-100">
                    {this.props.customSuggestions.map((customObj) => {
                                            if(!customObj.removed){

                      let tabId = "item" + customObj.id;
                      let itemChoice = customObj.tab_type == 1;

                      return (
                        <Tab.Pane eventKey={tabId}>
                          <h6 className="mb-3 mt-0 mb-3">
                            Add New Customization
                          </h6>
                          {itemChoice && (
                            <FoodItemForm
                              tabId={customObj.id}
                              payOptions={this.state.payOptions}
                              addNewCustomaization={this.props.addNewCustomaization}
                              removeFoodItem={this.props.removeFoodItem}
                              optionsFood={this.props.optionsFood}
                              getFoodPrice={this.getFoodPrice}
                              getFoodName={this.getFoodName}
                            ></FoodItemForm>
                          )}
                          {!itemChoice && (
                            <SuggestionItemForm
                              tabId={customObj.id}
                              payOptions={this.state.payOptions}
                              addNewCustomaization={this.props.addNewCustomaization}
                              removeAnswer={this.removeAnswer}
                 
                
                            ></SuggestionItemForm>
                          )}

                          <hr></hr>
                          {itemChoice && ( <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Available Free </th>
                                <th>Price</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(typeof (customObj.upsell_items) != "undefined") &&
                                customObj.upsell_items.length > 0 &&
                                customObj.upsell_items.map((itemObj) => {
                                  if(!itemObj.removed){

                                  return (
                                    <tr>
                                      <td>
                                        {" "}
                                        {this.getFoodName(itemObj.item)}
                                      </td>
                                   

                                      <td>
                                        {itemObj.free_available && "Yes"}
                                        {!itemObj.free_available && "No"}
                                      </td>

                                      <td>{itemObj.item_price}</td>
                                      <td>
                                        <Link
                                          className="btn btn-success btn-block btn-sm"
                                          onClick={() => {
                                            this.props.removeFoodItem(
                                              customObj.id,
                                              itemObj
                                            );
                                          }}
                                        >
                                          <Icofont icon="trash" />
                                        </Link>
                                      </td>
                                    </tr>
                                        );
                                        }})}
                            </tbody>
                          </Table>
                          
                          )}
                          
                          
                          {!itemChoice && ( <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Question Title</th>
                                <th>Question Type </th>
                                <th>Answers</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(typeof (customObj.custom_questions) != "undefined") &&
                                customObj.custom_questions.length > 0 &&
                                customObj.custom_questions.map((itemObj) => {
                                  if(!itemObj.removed){

                                  return (
                                    <tr>
                                      <td>
                                        {" "}
                                        { itemObj.quetion_title}
                                      </td>
                                      <td>
                                        {this.getQuestionType(
                                          itemObj.question_type
                                        )}
                                      </td>

                                      <td>
                                          <table>

                                          <th>Answer</th>
                                <th>Free </th>
                                <th>Charge</th>
                                {

itemObj.answers.map((answerObj)=>(


  <tr>

<td>{answerObj.answer_title}</td>
<td>
{answerObj.free_available && "Yes"}
                                        {!answerObj.free_available && "No"}

</td>
<td>{answerObj.item_price}</td>

  </tr>
))

                                }

                                          </table>



                                      </td>

                                    
                                      <td>
                                        <Link
                                          className="btn btn-success btn-block btn-sm"
                                          onClick={() => {
                                            this.props.removeAnswer(
                                              customObj.id,
                                              
                                              itemObj
                                            );
                                          }}
                                        >
                                          <Icofont icon="trash" />
                                        </Link>
                                      </td>
                                    </tr>
                                  );}
                                })}
                            </tbody>
                          </Table>
                          
                          )}
                          
                          <card className="btn btn-danger btn-block btn-sm">
                            {"Delete"}
                            <span
                              onClick={() => {
                                console.log(customObj);
                                this.props.removeTab(customObj);
                              }}
                            >
                              <Icofont icon="trash" />
                            </span>
                          </card>
                        </Tab.Pane>
                      );
                            }
                    })}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </span>
      </div>
    );
  }
}

/*
Component for Food Item Form
*/
class FoodItemForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.getFoodPrice = this.props.getFoodPrice;
    this.state = {
      addedItemscreateForm: { free_available: false},
    };
  }
  isFoodItemFormValid() {
    return (
      this.validator.fieldValid("food_item")
    );
  }
  //to handler for added Items in Form
  createAddedItemsFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.addedItemscreateForm };
    if (
      event.target.type == "text" ||
      event.target.type == "number" ||
      event.target.type == "textarea"
    ) {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;
      value = event.target.value;
      if (key == "food_item" && inputForm["free_available"] == false) {
        inputForm["item_price"] = this.getFoodPrice(value);
      }
    } else if (event.target.type == "checkbox") {
      key = event.target.name;
      value = event.target.checked;
      if (value == true) {
        delete inputForm["item_price"];
      }
    }

    inputForm[key] = value;
    this.setState({ addedItemscreateForm: inputForm });
  };
  render() {
    return (
      <div>
        <Form>
          <div className="form-row">
            <Form.Group className="col-md-8">
              <Form.Label>Food Item</Form.Label>
              {this.validator.message(
                "food_item",
                this.state.addedItemscreateForm["food_item"],
                "required"
              )}

              <Form.Control
                as="select"
                name="food_item"
                onChange={this.createAddedItemsFormHandler}
              >
                {this.props.optionsFood.map((foodObj) => {
                  return <option value={foodObj.id}>{foodObj.name}</option>;
                })}
              </Form.Control>
            </Form.Group>
           <Form.Group className="col-md-8">
              <Form.Check
                type="checkbox"
                name="free_available"
                onChange={this.createAddedItemsFormHandler}
                label="Available this item as Free"
              />
            </Form.Group>

            {this.state.addedItemscreateForm["free_available"] == false && (
              <Form.Group className="col-md-12">
                <Form.Label>Item Price</Form.Label>

                <InputGroup>
                  <Form.Control
                    type="number"
                    onChange={this.createAddedItemsFormHandler}
                    name="item_price"
                    placeholder="Item Price"
                    value={this.state.addedItemscreateForm["item_price"]}
                  />
                </InputGroup>
              </Form.Group>
            )}
            <Form.Group className="col-md-12 mb-0">
              <Link
                onClick={() => {
                  if (this.isFoodItemFormValid() == true) {
                    this.props.addNewCustomaization(
                      this.props.tabId,

                      this.state.addedItemscreateForm
                    );
                  } else {
                    this.validator.showMessages();
                  }
                }}
                className="btn btn-success btn-block btn-lg"
              >
                ADD
                <Icofont icon="long-arrow-right" />
              </Link>
            </Form.Group>
          </div>
        </Form>
      </div>
    );
  }
}

/*
Component for Food Item Form
*/
class SuggestionItemForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.getFoodPrice = this.props.getFoodPrice;
    this.state = {
      addedItemscreateForm: { answers: [],question_type:"2" },
    };
    this.addNewAnswer = this.addNewAnswer.bind(this);
    this.createAnswerFormHandler=this.createAnswerFormHandler.bind(this);
  }


    //to handler for added Items in Form
    createAnswerFormHandler = (event,id) => {
      let key = "";
      let value = "";
      let inputParams = {...this.state.addedItemscreateForm };
      let selectedForm={...inputParams.answers[id]}

      if (
        event.target.type == "text" ||
        event.target.type == "number" ||
        event.target.type == "textarea"
      ) {
        key = event.target.name;
        value = event.target.value;
      }  else if (event.target.type == "checkbox") {
        key = event.target.name;
        value = event.target.checked;
      }
  
      selectedForm[key] = value;
      inputParams.answers[id]=selectedForm;
      console.log(inputParams);
      this.setState({ addedItemscreateForm: inputParams });
    };


    removeAnswer = (answer) => {
      let inputParams = {...this.state.addedItemscreateForm };
      inputParams.answers.splice( inputParams.answers.indexOf(answer), 1);
      this.setState({ addedItemscreateForm: inputParams });

    };
  addNewAnswer = (id, answerForm = {}) => {
    let inputItems = { ...this.state.addedItemscreateForm };

    if (typeof id == "undefined") {
      let currentItem = {
        answer_title: "",
        item_price: 0,
        free_available: false,
      };
      inputItems.answers.push(currentItem);
    } else {
      let newAnswers = inputItems.answers.map((answerObj, idx) => {
        if (idx === id) {
          let currentItem = {
            answer_title: answerForm["answer_title"],
            item_price: answerForm["free_available"] ? 0 : answerForm["price"],
            free_available: answerForm["free_available"],
          };
          return currentItem;
        } else {
          return answerObj;
        }
      });
      inputItems.answers = { ...newAnswers };
    }
    this.setState({ addedItemscreateForm: inputItems });
  };
  isFoodItemFormValid() {
    return (
      this.validator.fieldValid("food_item")
    );
  }

  //to handler for added Items in Form
  createAddedItemsFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.addedItemscreateForm };
    if (
      event.target.type == "text" ||
      event.target.type == "number" ||
      event.target.type == "textarea"
    ) {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;
      value = event.target.value;
      if (key == "question_type") {
        /*if (value == "1") {
          delete inputForm["answers"];
          inputForm["answers"] = [];
          inputForm["answers"] = [
            { answer_title: "Yes", free_available: true, item_price: 0 },
            { answer_title: "No", free_available: true, item_price: 0 },
          ];
        } else {*/
          delete inputForm["answers"];

          inputForm["answers"] = [];
        
      }
    } else if (event.target.type == "checkbox") {
      key = event.target.name;
      value = event.target.checked;
    }

    inputForm[key] = value;
    this.setState({ addedItemscreateForm: inputForm });
  };
  render() {
    return (
      <div>
        <Form>
          <div className="form-row">
            <Form.Group className="col-md-12">
              <Form.Label>Question</Form.Label>
             
              <Form.Control
                type="textarea"
                onChange={this.createAddedItemsFormHandler}
                name="quetion_title"
                placeholder="Enter Question Title"
              />
            </Form.Group>
            <Form.Group className="col-md-6">
              <Form.Label>Question Type</Form.Label>
              {this.validator.message(
                "question_type",
                this.state.addedItemscreateForm["question_type"],
                "required"
              )}
              <Form.Control
                as="select"
                name="question_type"
                onChange={this.createAddedItemsFormHandler}
              >
                <option value="2">Multiple Choices</option>
                <option value="1">Single Choice</option>
              </Form.Control>
            </Form.Group>
            {
              <Form.Group className="col-md-6 pt-4">
                <Button
                  variant="secondary"

                  
                  onClick={() => {

                    this.addNewAnswer();
                  }}
                  size="sm"
                >
                  <i class="icofont-plus-circle"></i>
                  New Answer
                </Button>
              </Form.Group>
            }


            
            <Form.Group className="col-md-8">
              {this.state.addedItemscreateForm.answers.map((answerObj, idx) => (
                <card>   <Card.Body>
                      {
              this.validator.message(
                "answer_title",
                this.state.addedItemscreateForm.answers[idx]["answer_title"],
                "required"
              )}
                  <AnswerChoices
                    validator={this.validator}
                    customSugObj={this.props.customSugObj}
                    id={idx}
                    addedItemscreateForm={this.state.addedItemscreateForm}
                    addNewAnswer={this.addNewAnswer}
                    answer={answerObj}
                    createAnswerFormHandler={this.createAnswerFormHandler}
                  ></AnswerChoices>
              
                 
                 {this.state.addedItemscreateForm["question_type"] === "2" && (
                  <Form.Group className="col-md-8">
                <Button
                  variant="secondary"
                  onClick={(e) => {
                    this.removeAnswer(e,answerObj);
                  }}
                  size="sm"
                >
                  <i class="icofont-minus-circle"></i>
                </Button>
              </Form.Group>)}
              
              
              
              </Card.Body>
                </card>
              ))}
            </Form.Group>




            <Form.Group className="col-md-12 mb-0">
              <Link


onClick={(e) => {
  if (this.validator.allValid() == true) {
    
    e.target.setAttribute("disabled", "disabled");

    this.props.addNewCustomaization(
      this.props.tabId,
      this.state.addedItemscreateForm
    );
    this.setState({addedItemscreateForm:{ answers: [],question_type:"2" }});
  } else {
    this.validator.showMessages();
  }
}}
            
                className="btn btn-success btn-block btn-lg"
              >
                ADD
                <Icofont icon="long-arrow-right" />
              </Link>
            </Form.Group>
          </div>
        </Form>
      </div>
    );
  }
}

class AnswerChoices extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
        {" "}
        <Form.Label>Answer {" " + (this.props.id + 1)}</Form.Label>
       
        <Form.Control type="text" name="answer_title" 
        onChange={
          (e )=> {this.props.createAnswerFormHandler(e, this.props.id)}
          }
        value={this.props.answer.answer}
        placeholder="Type Answer" />
        <Form.Check
          type="checkbox"
          name="free_available"
          label="Available this Customaization Free"
          checked= {this.props.answer.free_available}

          onChange={
            (e )=> {this.props.createAnswerFormHandler(e, this.props.id)}
            }
        />

        {(!this.props.answer.free_available)&&
        (<div><Form.Label>Item Price</Form.Label>

        <InputGroup>
          <Form.Control
            type="number"
            name="item_price"
            placeholder="Item Price"
            checked= {this.props.answer.item_price}

            onChange={
              (e )=> {this.props.createAnswerFormHandler(e, this.props.id)}
              }
          />
        </InputGroup></div>)
        
            }
             
            
            </div>
      </div>
    );
  }
}

export default SuggestionTab;
